/*!
 * Copyright Optimus Ride 2019
 */

import { WaypointDescription, toWaypointDescription } from './waypoint-list';
import { ListWaypointsResponse as GrpcListWaypointsResponse } from '../../grpc/remote-monitor-command_pb';

export interface RouteNetworkInfo {
    operatingAreaId: number;
    waypoints: WaypointDescription[];
}

export const EmptyRouteNetworkInfo: RouteNetworkInfo = {
    operatingAreaId: -1,
    waypoints: [],
}

export function toRouteNetworkInfo(response: GrpcListWaypointsResponse): RouteNetworkInfo {
    const waypointList = response.getWaypointsList();
    return {
        operatingAreaId: response.getOperatingAreaId(),
        waypoints: waypointList.map(toWaypointDescription),
    };
}
